export default {
  name: 'notice-bar',
  components: {},
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "info"
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    console.log("Notice bar mounted")
  },
  methods: {

  }
}
